module.exports = __webpack_public_path__ + "static/favicons/apple-touch-icon-114x114-a248918eb39346111e734e6feb74fc59.png";